import styleInject from '../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".PaymentMethodIcon-module_paymentMethodIcon__ikO4b {\n  display: flex;\n  width: 40px;\n  max-width: 40px;\n  max-height: 40px;\n}\n.PaymentMethodIcon-module_paymentMethodIcon__ikO4b svg {\n  width: 40px;\n  height: auto;\n}";
var styles = {"paymentMethodIcon":"PaymentMethodIcon-module_paymentMethodIcon__ikO4b"};
styleInject(css_248z);

export { styles as default };
